import { Box, Container, Typography } from "@mui/material";
import { useLuxuryCountUp } from "./useCountUp";

const stats = [
  { value: 7, suffix: "", label: "UAE Locations", order: 1 },
  { value: 25, suffix: "+", label: "Spoken Languages", order: 2 },
  { value: 48, suffix: "+", label: "Nationalities", order: 3 },
  { value: 1000, suffix: "+", label: "Happy Clients", order: 4 },
  { value: 6000, suffix: "+", label: "Properties Listed on Portals", order: 5 },
];

function Stat({ value, suffix, label, showDivider }) {
  const count = useLuxuryCountUp(value, 6000);

  return (
    <Box
      sx={{
        textAlign: "center",
        px: { xs: 1, sm: 2 },
        position: "relative",
        width: "100%",
        ...(label === "Properties Listed on Portals" && {
          mt: { xs: 2, md: 0 },
          pt: { xs: 2.5, md: 0 },
          // borderTop: {
          //   xs: "1px solid rgba(0,0,0,0.06)",
          //   md: "none",
          // },
        }),
      }}
    >
      {/* Number */}
      <Typography
        sx={{
          fontSize: {
            xs: label === "Properties Listed on Portals" ? "2.6rem" : "2.1rem",
            sm: "2.6rem",
            md: "3.4rem",
          },
          fontWeight: 600,
          color: "var(--color-primary-dark)",
          letterSpacing: "-0.6px",
          lineHeight: 1.1,
        }}
      >
        {count.toLocaleString()}
        <Box
          component="span"
          sx={{
            color: "var(--color-gold)",
            ml: 0.3,
            fontWeight: 500,
          }}
        >
          {suffix}
        </Box>
      </Typography>

      {/* Gold underline */}
      <Box
        sx={{
          width: 26,
          height: 2,
          backgroundColor: "var(--color-gold)",
          mx: "auto",
          my: 1,
          opacity: 0.8,
        }}
      />

      {/* Label */}
      <Typography
        sx={{
          fontSize: "0.85rem",
          color: "var(--color-text-muted)",
          letterSpacing: "0.35px",
          lineHeight: 1.4,
          textAlign: "center",
          px: { xs: 2, md: 0 }, // ✅ breathing room on full-width card
        }}
      >
        {label}
      </Typography>

      {/* Divider – desktop only */}
      {showDivider && (
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: "20%",
            height: "60%",
            width: "1px",
            backgroundColor: "rgba(0,0,0,0.06)",
            display: { xs: "none", md: "block" },
          }}
        />
      )}
    </Box>
  );
}

export default function CompanyStatsSection() {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "var(--color-bg)",
        py: { xs: 0.8, md: 0.8 },
      }}
    >
      <Container maxWidth="lg">
        {/* Soft inner wrapper */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "18px",
            py: { xs: 3.5, md: 4.5 }, // ⬅ reduced
            px: { xs: 1.5, md: 3 }, // ⬅ reduced side padding
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "space-between" },
              rowGap: { xs: 3, md: 0 },
            }}
          >
            {stats.map((stat, index) => {
              const isLast = stat.label === "Properties Listed on Portals";

              return (
                <Box
                  key={index}
                  sx={{
                    flexBasis: {
                      xs: isLast ? "100%" : "50%",
                      sm: "33.333%",
                      md: "20%",
                    },
                    order: {
                      xs: stat.order,
                      md: "initial",
                    },
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Stat {...stat} showDivider={!isLast} />
                </Box>
              );
            })}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
